import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import r from "../../shared-lib/braze-shared-lib.js";
import qt from "../models/backend-errors.js";
var b = {
  Hs: function Hs(t) {
    var e, o;

    try {
      var n = function n() {
        r.D.error("This browser does not have any supported ajax options!");
      };

      if (window.XMLHttpRequest ? (e = new XMLHttpRequest(), e || n()) : n(), null != e) {
        var _r = function _r() {
          "function" == typeof t.error && t.error(e.status), "function" == typeof t.Rl && t.Rl(!1);
        };

        e.onload = function () {
          var o = !1;
          if (4 === e.readyState) if (o = e.status >= 200 && e.status < 300 || 304 === e.status, o) {
            if ("function" == typeof t.S) {
              var _o, _r2;

              try {
                _o = JSON.parse(e.responseText), _r2 = e.getAllResponseHeaders();
              } catch (o) {
                var _n2 = {
                  error: "" === e.responseText ? qt.oa : qt.ha,
                  response: e.responseText
                };
                t.S(_n2, _r2);
              }

              _o && t.S(_o, _r2);
            }

            "function" == typeof t.Rl && t.Rl(!0);
          } else _r();
        }, e.onerror = function () {
          _r();
        }, e.ontimeout = function () {
          _r();
        }, o = JSON.stringify(t.data), e.open("POST", t.url, !0), e.setRequestHeader("Content-type", "application/json"), e.setRequestHeader("X-Requested-With", "XMLHttpRequest");

        var _n = t.headers || [];

        var _iterator = _createForOfIteratorHelper(_n),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _t = _step.value;
            e.setRequestHeader(_t[0], _t[1]);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        e.send(o);
      }
    } catch (t) {
      r.D.error("Network request error: ".concat(t.message));
    }
  }
};
export var readResponseHeaders = function readResponseHeaders(t) {
  var e = {};
  var o = t.toString().split("\r\n");
  if (!o) return e;
  var r, n;

  var _iterator2 = _createForOfIteratorHelper(o),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _t2 = _step2.value;
      _t2 && (r = _t2.slice(0, _t2.indexOf(":")).toLowerCase().trim(), n = _t2.slice(_t2.indexOf(":") + 1).trim(), e[r] = n);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return e;
};
export default b;